// extracted by mini-css-extract-plugin
export default {"saveButton":"CardDescription_saveButton--b79"};